import "./Otts.css";
import React from "react";
import amazonprime from "../../Assets/otts/amazonprime.jpg";
import jiohotstar from "../../Assets/otts/jiohotstar.jpg";
import aha from "../../Assets/otts/aha.png";
import zee5 from "../../Assets/otts/zee5.jpg";
import hungama from "../../Assets/otts/hungama.png";
import altbalaji from "../../Assets/otts/altbalaji.jpg";
import etv from "../../Assets/otts/etv.png";
import sunnxt from "../../Assets/otts/sunnxt.jpg";
import netflix from "../../Assets/otts/netflix.jpg";

const ottLogos = [
    // amazonprime,
    jiohotstar,
    aha,
    zee5,
    hungama,
    altbalaji,
    etv,
    sunnxt,
    netflix,
];

function Otts() {
    return (
        <section className="ott-section">
            <p className="ott-subtitle">OTT + TV CHANNELS COMBO AVAILABLE</p>
            <h2 className="section-title">
                Achampet's gateway to unlimited entertainment
            </h2>

            <div className="ott-scroll-wrapper">
                <div className="ott-logos">
                    {[...ottLogos, ...ottLogos].map((logo, index) => (
                        <div className="ott-logo" key={index}>
                            <img src={logo} alt="OTT" />
                        </div>
                    ))}
                </div>
            </div>

            <div className="ott-info">
                WiFi + 29 OTTs + 300 FTA Live Channels
            </div>
        </section>
    );
}

export default Otts;
